export enum ApiTagsEnum {
  PICKEMS = 'PICKEMS',
  GET_LEADERBOARD = 'GET_LEADERBOARD',
}
